<template>
	<v-container 
		fluid
		fill-height
		class="loader-container"
	>
		<v-layout
			align-center 
			justify-center
		>
			<v-flex md5>
        <!-- Inserire qui il contenuto dei container laterali -->
      </v-flex>

			<v-flex>
				<v-card
					color
					dark
				>
					<v-card-title>
						<v-icon class="mr-3">fas fa-exclamation-triangle</v-icon>
						<h2>Please wait</h2>
					</v-card-title>
					<v-card-text>
						Your transaction is being processed: please wait and don't close this window.
						<v-progress-linear
							indeterminate
							color="white"
							class="mb-0"
						/>
					</v-card-text>
				</v-card>
			</v-flex>
			
			<v-flex md5>
        <!-- Inserire qui il contenuto dei container laterali -->
      </v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'

export default {
	data () {
		return {
		
		}
	},

	computed: {
  
	},

	watch: {
	
	},

	methods: {
	
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/index.scss';

.loader-container {
	position: absolute;
	z-index: 4;
	top: 0px;
	background-color: rgba(0,0,0,0.5); /* Black background with opacity */
}

</style>
